<template>
  <el-form
    ref="form"
    :label-position="labelPosition"
    :model="form"
    :rules="rules"
    label-width="80px"
  >
    <el-form-item
      label="转发策略"
      prop="strategyId"
    >
      <el-select
        style="width: 100%"
        v-model="form.strategyId"
        placeholder="选择策略"
        clearable
      >
        <el-option
          v-for="(item,index) in sourceTypeList"
          :key="index"
          :label="item.strategyName"
          :value="item.id"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      label="文章类型"
      prop="contentType"
    >
      <el-radio
        v-for="item in contentTypeList"
        :key="item.value"
        v-model="form.contentType"
        :label="item.value"
      >{{item.name}}</el-radio>
    </el-form-item>
    <el-form-item
      v-if="form.contentType ==1"
      label="文章内容"
      prop="contentText"
    >
      <el-input
        type="textarea"
        placeholder="请输入"
        v-model="form.contentText"
      ></el-input>
    </el-form-item>
    <el-form-item
      v-if="form.contentType ==2"
      label="文章内容"
      prop="contentImg"
    >
      <el-input
        v-model="form.contentImg"
        placeholder="图片链接"
      >
        <ossUploader
          class="pointer"
          slot="append"
          @uploaded="form.contentImg=$event"
        >
        </ossUploader>
      </el-input>
    </el-form-item>
    <el-form-item
      v-if="form.contentType ==3"
      label="文章内容"
      prop="contentEdit"
    >
      <quill-editor
        ref="editor"
        :defaultValues="form.contentEdit"
        @catchData="catchData"
      ></quill-editor>
    </el-form-item>
    <el-form-item
      v-if="form.contentType ==4"
      label="视频链接"
      prop="contentVideo"
    >
      <el-input
        v-model="form.contentVideo"
        placeholder="视频链接"
      >
        <ossUploader
          class="pointer"
          slot="append"
          @uploaded="form.contentVideo=$event"
        ></ossUploader>
      </el-input>
    </el-form-item>
    <template v-if="form.contentType ==5">
      <el-form-item
        label="视频链接"
        prop="contentVideoTextUrl"
      >
        <el-input
          v-model="form.contentVideoTextUrl"
          placeholder="视频链接"
        >
          <ossUploader
            class="pointer"
            slot="append"
            @uploaded="form.contentVideoTextUrl=$event"
          ></ossUploader>
        </el-input>
      </el-form-item>
      <el-form-item
        label="文字内容"
        prop="contentVideoText"
      >
        <quill-editor
          :defaultValues="form.contentVideoText"
          @catchData="form.contentVideoText=$event"
        ></quill-editor>
      </el-form-item>
    </template>
    <template v-if="form.contentType ==6">
      <el-form-item
        label="文件链接"
        prop="contentFileUrl"
      >
        <el-input
          v-model="form.contentFileUrl"
          placeholder="文件链接"
        >
          <ossUploader
            class="pointer"
            slot="append"
            @uploaded="form.contentFileUrl=$event"
          ></ossUploader>
        </el-input>
      </el-form-item>
      <el-form-item label="文字说明">
        <quill-editor
          :defaultValues="form.contentFileText"
          @catchData="form.contentFileText=$event"
        ></quill-editor>
      </el-form-item>
    </template>
  </el-form>
</template>

<script>
import formLabalPosition from "@/mixins/formLabalPosition";
import quillEditor from "@/components/public/quillEditor";
import ossUploader from "@/components/public/ossUploader";
import {
  buildStrategyArticleContent,
  parseStrategyArticleContent,
  queryTypeList,
  strategyArticleContentTypes,
} from "@/api/wx/strategyActicle";

const isValidHttpUrl = value => {
  try {
    const url = new URL(value);
    return ['http:', 'https:'].includes(url.protocol) && Boolean(url.hostname);
  } catch {
    return false;
  }
};

const validateMediaUrl = (rule, value, callback) => {
  if (!value || isValidHttpUrl(value)) {
    callback();
  } else {
    callback(new Error('请输入有效的HTTP(S)地址'));
  }
};

const validateRequiredRichText = (rule, value, callback) => {
  const text = String(value || '')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;|&#160;|&#x0*a0;/gi, '')
    .trim();
  callback(text ? undefined : new Error('请输入文字内容'));
};

let origin = {
  strategyId: '',
  contentType: 1,
  contentText: '',
  contentImg: '',
  contentEdit: '',
  contentVideo: '',
  contentVideoTextUrl: '',
  contentVideoText: '',
  contentFileUrl: '',
  contentFileText: '',
}
export default {
  name: "statrgyArticleForm",
  components: {
    quillEditor,
    ossUploader,
  },
  props: {
    formData:{
      type: Object,
      default(){
        return {
          id: ''
        };
      }
    }
  },
  data() {
    return {
      sourceTypeList: [],
      contentTypeList: strategyArticleContentTypes,
      form: JSON.parse(JSON.stringify(origin)),
      rules: {
        strategyId: [
          { required:true, message: '请选择', trigger: 'blur' },
        ],
        contentType: [
          { required:true, message: '请选择', trigger: 'change' },
        ],
        contentText: [
          { required:true, message: '请输入', trigger: 'blur' },
        ],
        contentImg: [
          { required:true, message: '请输入', trigger: 'blur' },
        ],
        contentEdit: [
          { required:true, message: '请输入', trigger: 'blur' },
        ],
        contentVideo: [
          { required:true, message: '请输入', trigger: 'blur' },
          { validator:validateMediaUrl, trigger: 'blur' },
        ],
        contentVideoTextUrl: [
          { required:true, message: '请输入', trigger: 'blur' },
          { validator:validateMediaUrl, trigger: 'blur' },
        ],
        contentVideoText: [
          { validator:validateRequiredRichText, trigger: 'blur' },
        ],
        contentFileUrl: [
          { required:true, message: '请输入', trigger: 'blur' },
          { validator:validateMediaUrl, trigger: 'blur' },
        ],
      },
    }
  },
  mixins: [formLabalPosition],
  watch:{
    formData:{
      handler(newValue){
        if(newValue.id){
          this.assigen(newValue);
        }
      },
      deep: true,
    }
  },

  created(){
    this.getTypeList();
  },
  methods: {
    getTypeList(){
      queryTypeList({
        page: 1,
        limit: 500,
        'sidx': 'id',
        'order':'desc',
      }).then((res) => {
        this.sourceTypeList = res.page.list;
      })
    },
    reset(){
      this.form = JSON.parse(JSON.stringify(origin));
    },
    assigen(data){
      this.form = JSON.parse(JSON.stringify(origin));
      this.form.id = data.id;
      this.form.strategyId = data.strategyId;
      this.form.contentType = data.contentType;
      Object.assign(this.form, parseStrategyArticleContent(data.contentType, data.content));
    },
    // 菜单树设置当前选中节点
    // 上级菜单有时候编辑的时候没有对得上,有点问题, todo

    selfValidate() {
      this.$refs.form.validate((valid) => {
        if(valid){
          this.$emit('submit', {
            ...this.form,
            content: buildStrategyArticleContent(this.form),
          });
        }
      })
    },
    selfClear(){
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
      this.reset();
    },
    catchData(content){
      this.form.contentEdit = content;
    }
  },
}
</script>

<style scoped>

</style>
